// ═══════════════════════════════════════════════════════════════
// FRONTEND API SERVICE: Other Deductions
// Path: src/api/otherDeductions.js
// ═══════════════════════════════════════════════════════════════

import apiConfig from './config';

const API_BASE = '/other-deductions';

/**
 * Crear nueva deducción
 */
export const createOtherDeduction = async (data) => {
  try {
    const response = await apiConfig.post(API_BASE, data);
    return response.data;
  } catch (error) {
    console.error('Error creating deduction:', error);
    throw error;
  }
};

/**
 * Obtener deducciones de una compañía
 */
export const getOtherDeductions = async (companyId, filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString();
    const url = `${API_BASE}/company/${companyId}${params ? `?${params}` : ''}`;
    const response = await apiConfig.get(url);
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching deductions:', error);
    throw error;
  }
};

/**
 * Obtener deducciones de un empleado
 */
export const getEmployeeDeductions = async (employeeId, includeInactive = false) => {
  try {
    const url = `${API_BASE}/employee/${employeeId}${includeInactive ? '?includeInactive=true' : ''}`;
    const response = await apiConfig.get(url);
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching employee deductions:', error);
    throw error;
  }
};

/**
 * Obtener una deducción por ID
 */
export const getOtherDeduction = async (id) => {
  try {
    const response = await apiConfig.get(`${API_BASE}/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching deduction:', error);
    throw error;
  }
};

/**
 * Actualizar deducción
 */
export const updateOtherDeduction = async (id, data) => {
  try {
    const response = await apiConfig.put(`${API_BASE}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating deduction:', error);
    throw error;
  }
};

/**
 * Eliminar deducción
 */
export const deleteOtherDeduction = async (id) => {
  try {
    const response = await apiConfig.delete(`${API_BASE}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting deduction:', error);
    throw error;
  }
};

/**
 * Avanzar cuota de una deducción a plazos
 */
export const advanceCuota = async (id) => {
  try {
    const response = await apiConfig.post(`${API_BASE}/${id}/advance-cuota`);
    return response.data;
  } catch (error) {
    console.error('Error advancing cuota:', error);
    throw error;
  }
};

/**
 * Obtener resumen de deducciones
 */
export const getDeductionsSummary = async (companyId) => {
  try {
    const response = await apiConfig.get(`${API_BASE}/company/${companyId}`);
    return response.data.stats || {};
  } catch (error) {
    console.error('Error fetching summary:', error);
    return {};
  }
};

export default {
  createOtherDeduction,
  getOtherDeductions,
  getEmployeeDeductions,
  getOtherDeduction,
  updateOtherDeduction,
  deleteOtherDeduction,
  advanceCuota,
  getDeductionsSummary
};
